export const TASKS_TYPES = {
    EXERCISE: 'exercise',
    SURVEY: 'survey'
}

export const SURVEY_IDS = {
    ON_BOARDING_SURVEY: 'OnBoardingSurvey',
}